import React from 'react'
import Flag from '../general/Flag'

const userLanguageFlags = {
	'en-US': 'US',
	'en-GB': 'GB',
	'de-DE': 'DE',
	'fr-FR': 'FR',
	'it-IT': 'IT',
	'es-ES': 'ES',
	'pt-PT': 'PT'
}

const UserLanguage = ({ language }) => (
	<Flag country={userLanguageFlags[language]} />
)

export default UserLanguage
